<ion-toolbar mode="ios">
    <ion-buttons slot="start">
        <ion-back-button
            class="sub-headline-bold"
            text="{{ 'GLOBAL.HEADER.BACK_BUTTON' | translate }}"
            icon="arrow-back"
            defaultHref="/settings"
        ></ion-back-button>
    </ion-buttons>
    @if (title) {
        <ion-title class="sub-headline-bold">{{ title }}</ion-title>
    }
    @if (icon) {
        <ion-buttons slot="end">
            <ion-button (click)="triggerAction()" [class.background]="background" [disabled]="disabled">
                @if (displayIcon) {
                    <ion-icon [class.loader]="loader" slot="icon-only" [src]="icon" [color]="iconColor"></ion-icon>
                }
            </ion-button>
        </ion-buttons>
    }
</ion-toolbar>
